import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

// Example items, to simulate fetching from another resources.

type TProps = {
  itemsPerPage: number;
  getCurrentPage: (page: number) => void;
  totalItems: number;
};

export const Pagination = ({
  itemsPerPage,
  getCurrentPage,
  totalItems,
}: TProps) => {
  // We start with an empty list of items.
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.

  useEffect(() => {
    // Fetch items from another resources.
    setPageCount(Math.ceil(totalItems / itemsPerPage));
  }, [itemsPerPage, totalItems]);

  // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    const selectedPage = event.selected + 1;
    getCurrentPage(selectedPage);
  };

  return (
    <div className="w-full flex justify-center my-10 ">
      <ReactPaginate
        breakLabel="..."
        activeClassName="bg-primary text-black px-3 py-1 rounded-full"
        className="flex justify-center w-6/12 gap-5 bg-white shadow-sm text-secondary p-3 rounded-3xl place-items-center"
        nextLabel={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 "
            fill="none"
            viewBox="0 0 24 24"
            stroke="black"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        }
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        
        
        previousLabel={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 "
            fill="none"
            viewBox="0 0 24 24"
            stroke="black"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        }
        // renderOnZeroPageCount={null}
      />
    </div>
  );
};
